var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.870195 25.5147L0.840195 25.5447C0.435195 24.6597 0.180195 23.6547 0.0751953 22.5447C0.180195 23.6397 0.465195 24.6297 0.870195 25.5147ZM10.5002 12.5697C11.447 12.5697 12.3551 12.1936 13.0246 11.5241C13.6941 10.8546 14.0702 9.94651 14.0702 8.99969C14.0702 8.05286 13.6941 7.14482 13.0246 6.47532C12.3551 5.80581 11.447 5.42969 10.5002 5.42969C9.55337 5.42969 8.64533 5.80581 7.97582 6.47532C7.30632 7.14482 6.9302 8.05286 6.9302 8.99969C6.9302 9.94651 7.30632 10.8546 7.97582 11.5241C8.64533 12.1936 9.55337 12.5697 10.5002 12.5697Z",
    fill: "#DDDFDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.285 0H8.715C3.255 0 0 3.255 0 8.715V21.285C0 22.92 0.285 24.345 0.84 25.545C2.13 28.395 4.89 30 8.715 30H21.285C26.745 30 30 26.745 30 21.285V8.715C30 3.255 26.745 0 21.285 0ZM27.555 15.75C26.385 14.745 24.495 14.745 23.325 15.75L17.085 21.105C15.915 22.11 14.025 22.11 12.855 21.105L12.345 20.685C11.28 19.755 9.585 19.665 8.385 20.475L2.775 24.24C2.445 23.4 2.25 22.425 2.25 21.285V8.715C2.25 4.485 4.485 2.25 8.715 2.25H21.285C25.515 2.25 27.75 4.485 27.75 8.715V15.915L27.555 15.75Z",
    fill: "#DDDFDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBip);
export default __webpack_public_path__ + "static/media/bip.b01ec5ba7da86b16743fce01c479cf6c.svg";
export { ForwardRef as ReactComponent };